import React from 'react'
import { render } from 'react-dom'

import AppProviders from './AppProviders'
import App from './App'

import { store } from './store'

import '../sass/main.scss'
import 'font-awesome-sass-loader'

window.apigClient = window.apigClientFactory.newClient({ region: 'us-east-1' })
const config = { 
  maintenance: !!OE_ENV.MAINTENANCE_MODE && OE_ENV.MAINTENANCE_MODE === 'true'
}

render(
  <AppProviders store={store}>
    <App maintainance = {config.maintenance}/>
  </AppProviders>,
  document.getElementById('root')
)
